import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { CrmSystemCheckboxProps } from ".";

export function CrmSystemCheckbox({ crmSystem, count, ...props }: CrmSystemCheckboxProps) {
    return (
        <div className="flex items-center gap-2 overflow-hidden bg-gray-100 border rounded-md">
            <div className="w-2 h-full" style={{ backgroundColor: crmSystem.branding.color }}></div>
            <div className="flex items-center gap-2 py-1 pe-2">
                <Checkbox
                    className="rounded-md bg-white data-[state=checked]:bg-gray-600 w-4 h-4"
                    id={`item-${crmSystem.id}`}
                    {...props}
                />
                <Label htmlFor={`item-${crmSystem.id}`} className="flex gap-1">
                    {crmSystem.name}
                    {(count != null) && <span>({count})</span>}
                </Label>
            </div>
        </div>
    )
}